import axios from 'axios';
import { getField, updateField } from 'vuex-map-fields';

const url = 'https://api.bi-assobens.com.br/v1';
// const url = 'http://localhost:3000/v1';

export default {
  namespaced: true,
  state: {
    list: [],
    total: 0,
  },
  mutations: {
    updateField,
    SET_MY_STOCK(state, payload) {
      state.list = payload.estoque;
      state.total = payload.total;
    },
  },
  actions: {
    async getMyStock({ commit }, obj) {
      const { data } = await axios.get(`${url}/estoque`, {
        headers: { 'x-access-token': obj.token },
        params: {
          ctcli: obj.ctcli,
          page: obj.page,
          limit: obj.limit,
          filter: obj.filter ? obj.filter : null,
          aop: obj.aop,
          regiao_mb: obj.regiao_mb,
          published: obj.published,
          segmentos: obj.segmentos,
        },
      });
      commit('SET_MY_STOCK', data);
    },

    // async updateStock({ commit }, obj) {
    //   let finalUrl = `${url}/`;
    //   if (obj.status) {
    //     finalUrl += `${urlPublicar}`;
    //   } else {
    //     finalUrl += `${urlRemover}`;
    //   }
    //   await axios.post(`${finalUrl}`,
    //     { stockId: obj.index },
    //     { headers: { 'x-access-token': obj.token } });
    // },

    // eslint-disable-next-line no-unused-vars
    async addPublish({ commit }, obj) {
      await axios.post(
        `${url}/publicar`,
        {
          stockId: obj.stockId,
          name: obj.nome,
          phone: obj.telefone,
          account: obj.account,
        },
        { headers: { 'x-access-token': obj.token } },
      );
    },
    // eslint-disable-next-line no-unused-vars
    async removePublish({ commit }, obj) {
      await axios.post(
        `${url}/remover-publicado`,
        {
          stockId: obj.stockId,
        },
        { headers: { 'x-access-token': obj.token } },
      );
    },
  },
  getters: { getField },
};
